/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import Spinner from './Spinner';

type Props = {
  className?: string,
  pad?: boolean
};

const defaultProps = {
  className: undefined,
  pad: false
};

const Wrapper = styled.div(
  {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto'
  },
  ({ theme, pad }) =>
    pad
      ? {
          padding: theme.spacing.small
        }
      : {}
);

function Loader({ className, pad, ...otherProps }: Props) {
  return (
    <Wrapper className={className} pad={pad}>
      <Spinner {...otherProps} />
    </Wrapper>
  );
}

Loader.defaultProps = defaultProps;

export default Loader;
